import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit, AfterViewInit, ElementRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from '../Shared/toaster.service';
import { MasterParkingDevice } from '../Models/master-device';
import { DeviceService } from '../ApiServices/device.service';
import { MasterRolePermission } from '../Models/master-role-permission';
import { SELECT_DEVICE_LOG } from '../Models/Report/SELECT_DEVICE_LOG';
import { ReportApiService } from '../ApiServices/report-api.service';
import { IdList, ReportParameters } from '../Models/report-parameters';

import * as $ from 'jquery';
import { exit } from 'node:process';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterParkingDeviceAction } from '../Models/master-device-action';

@Component({
  selector: 'app-parking-stations',
  templateUrl: './parking-stations.component.html',
  styleUrls: ['./parking-stations.component.css'],
  animations: [
    trigger('widthGrow', [
      state('closed', style({
        width: 0,
        display: 'none'
      })),
      state('open', style({
        width: 720,
        display: 'block'
      })),
      transition('* => *', animate(200))
    ]),
  ]
})
export class ParkingStationsComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private formbuilder: FormBuilder, private router: Router, private toasterService: ToasterService, private deviceService: DeviceService, private reportApiService: ReportApiService) { }

  deviceList: MasterParkingDevice[] = [];
  deviceObj: MasterParkingDevice;

  SELECT_DEVICE_LOG_LIST: SELECT_DEVICE_LOG[] = [];
  reportParameters: ReportParameters;

  reasonForm: FormGroup;
  deviceActionObj: MasterParkingDeviceAction;

  state: string = 'open';

  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      if (sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(MasterRolePermission.ViewParkingStations.rolePermission) < 0) {
        alert("Unauthorised access");
        this.router.navigateByUrl('/index');
        return;
      } else {
        this.reportParameters = new ReportParameters();
        this.LoadDeviceList();
        this.initializeReasonForm();
      }
    }
  }

  LoadDeviceList() {
    this.deviceService.getDevices()
      .subscribe((deviceresponse) => {
        this.deviceList = deviceresponse;
      }, (error) => {
        console.log(error);
      }
      );
  }

  sortByEntry(prop: string) {
    return this.deviceList.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1).filter(item => !item.GATE_TYPE.includes("Exit"));
  }

  sortByExit(prop: string) {
    return this.deviceList.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1).filter(item => !item.GATE_TYPE.includes("Entry"));
  }

  DeviceAction(DEVICE_ID, action) {
    this.reasonForm.controls["reason"].setValue('');
    this.reasonForm.controls["deviceId"].setValue(DEVICE_ID);
    this.reasonForm.controls["datetime"].setValue(new Date().toISOString());
    this.reasonForm.controls["action"].setValue(action);
   

    $('#deviceActionReasonModalButton').click();
  }

  ExitMatch(DEVICE_NAME) {
    alert(DEVICE_NAME);
    return DEVICE_NAME.toString().toLowerCase().indexOf("exit") > -1;
  }

  ExitMatchController(READING_FUNCTION) {
    //alert(READING_FUNCTION);
    
    if(READING_FUNCTION=="controller"){
    return false;
  } else
  {return true;
  }
  }

  initializeReasonForm() {
    this.reasonForm = this.formbuilder.group({
      reason: [''],
      deviceId: [''],
      datetime: [''],    
      action: ['']
    });

  }

  get f() { return this.reasonForm.controls; }

  resetReasonForm() {
    this.reasonForm.reset({
      reason: '',
      deviceId: '',
      datetime: '',      
      action: ''
    });
  }

  onReasonSubmit() {
    var masterParkingDeviceAction = new MasterParkingDeviceAction();
    masterParkingDeviceAction.DEVICE_ID = parseInt(this.reasonForm.controls["deviceId"].value);
    masterParkingDeviceAction.ACTION = this.reasonForm.controls["action"].value;
//alert(this.reasonForm.controls["action"].value);

    this.deviceService.AddDeviceCommand(masterParkingDeviceAction).subscribe((resp) => {
      this.toasterService.Success("Command Sent Successfully", "Info");
    }, (err) => {

    });

    this.deviceActionObj = new MasterParkingDeviceAction();
    this.deviceActionObj.DEVICE_ID = parseInt(this.reasonForm.controls["deviceId"].value);
    this.deviceActionObj.ACTION = this.reasonForm.controls["action"].value;
    this.deviceActionObj.DATETIME = this.reasonForm.controls["datetime"].value;
    this.deviceActionObj.REASON = this.reasonForm.controls["reason"].value;
    this.deviceActionObj.USER_ID = parseInt(sessionStorage.getItem('token').toString().trim());
    this.deviceService.InsertUpdateDeviceAction(this.deviceActionObj).subscribe((resp) => {
      if (resp.status == 0) {
      }
      else {
      }
    }, (err) => {
    });

    this.resetReasonForm();
    $('#deviceActionReasonModalCloseButton').click();
  }
  DeviceLogs(DEVICE_ID) {
    this.reportParameters.fromdate = '' + DEVICE_ID;
    this.SELECT_DEVICE_LOG_LIST = [];
    this.reportApiService.SELECT_DEVICE_LOG(this.reportParameters).subscribe(w => {
      this.SELECT_DEVICE_LOG_LIST = w;
      $('#deviceLogsModalButton').click();
    })
  }
}
